import { scoreBaseball, scoreField } from "@sportsmet/theme/scores";
import type { ReactNode } from "react";

import { BasesDiamond } from "./BasesDiamond";
import type { typeLiveStateWire } from "./liveStateTypes";
import { OutsDots } from "./OutsDots";

export const LiveStateRowGlyph = (props: {
  liveState: typeLiveStateWire;
  awayTeamId?: string;
  homeTeamId?: string;
}): ReactNode => {
  const baseball = scoreBaseball(props.liveState);
  const field = scoreField(props.liveState, props.awayTeamId, props.homeTeamId);
  const football = props.liveState.football ?? null;
  const downAndDistance = props.liveState.downAndDistanceLabel ?? "";
  const footballLine =
    downAndDistance !== "" ? (
      <span
        data-testid="score-row-live-down-and-distance"
        className="tabular-nums"
      >
        {downAndDistance}
      </span>
    ) : football !== null ? (
      <span data-testid="score-row-live-ball-spot" className="tabular-nums">
        {football.ballSpotLabel}
      </span>
    ) : null;
  return (
    <span
      data-testid="score-row-live-state"
      className="flex min-w-0 flex-col text-small text-ink-secondary"
    >
      {baseball !== null || footballLine !== null ? (
        <span
          aria-hidden="true"
          data-testid="score-row-live-state-visual"
          className="flex flex-col items-start gap-1"
        >
          {baseball !== null ? (
            <span
              data-testid="score-row-live-baseball"
              className="flex flex-col items-center gap-1"
            >
              {baseball.bases !== null ? (
                <BasesDiamond
                  isFirstOccupied={baseball.bases[0]}
                  isSecondOccupied={baseball.bases[1]}
                  isThirdOccupied={baseball.bases[2]}
                  size="row"
                />
              ) : null}
              {baseball.outs !== null ? (
                <OutsDots outs={baseball.outs} size="row" />
              ) : null}
            </span>
          ) : null}
          {baseball !== null && props.liveState.baseball?.countLabel ? (
            <span
              data-testid="score-row-live-count"
              className="hidden tabular-nums sm:inline"
            >
              {props.liveState.baseball.countLabel}
            </span>
          ) : null}
          {field !== null ? (
            <svg
              data-testid="score-row-live-field"
              aria-hidden="true"
              viewBox="0 0 100 16"
              className="h-4 w-full max-w-26"
            >
              <path
                d="M8 8H92"
                stroke="currentColor"
                strokeDasharray="2 3"
                className="text-ink-tertiary"
              />
              <g fill="currentColor" className="text-ink-tertiary">
                <circle cx="4" cy="8" r="3" />
                <circle cx="96" cy="8" r="3" />
              </g>
              <g fill="currentColor" className="text-primary">
                {field.direction === 0 ? (
                  <circle cx={field.x} cy="8" r="3" />
                ) : (
                  <path
                    d={`M${field.x - field.direction * 5} 3 L${field.x + field.direction * 3} 8 L${field.x - field.direction * 5} 13Z`}
                  />
                )}
              </g>
            </svg>
          ) : null}
          {footballLine}
        </span>
      ) : null}
      <span className="sr-only" data-testid="score-row-live-state-text">
        {props.liveState.summaryLabel}
      </span>
    </span>
  );
};
